import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedManga from "./components/FeaturedManga";
import RankingSection from "./components/RankingSection";
import LatestUpdates from "./components/LatestUpdates";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "皮皮漫画网 - 韩漫推荐与日漫系列 | 国漫大图全彩追更",
          "url": "https://pipimanhua.com/",
          "description": "皮皮漫画网专注日韩与国漫精品推荐，韩漫排行榜实时更新，日漫系列全集下拉畅读，国漫大图高清全彩。",
          "isPartOf": {
            "@type": "WebSite",
            "name": "皮皮漫画网",
            "url": "https://pipimanhua.com/",
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedManga />
        <RankingSection />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}